@if (chatlio.showAppLauncher()) {
  <button
    type="button"
    class="support-chat-launcher"
    data-testid="support-chat-launcher"
    [style.bottom.px]="chatlio.launcherBottomInsetPx()"
    (click)="openChat()"
    *transloco="let t; prefix: 'support-chat'"
    [attr.aria-label]="t('launcher-label')"
  >
    <fa-icon [icon]="['far', 'comments']" aria-hidden="true" />
  </button>
}
